// reducer.ts
import {
    ChatViewModel,
    ChatDetailsViewModel,
    ChatMessageViewModel,
} from "../../configuration/api/apiSchema";

export interface ChatState {
    chats: ChatViewModel[];
    chatDetails: ChatDetailsViewModel | null;
    loading: boolean;
    error: any;
}

const initialState: ChatState = {
    chats: [],
    chatDetails: null,
    loading: false,
    error: null,
};

export const reducer = (state = initialState, action: any): ChatState => {
    switch (action.type) {
        case "GET_CHATS_REQUEST":
            return { ...state, loading: true };
        case "GET_CHATS_SUCCESS":
            return { ...state, loading: false, chats: action.payload };
        case "GET_CHATS_FAILURE":
            return { ...state, loading: false, error: action.payload };
        case "GET_CHAT_DETAILS_REQUEST":
            return { ...state, loading: true };
        case "GET_CHAT_DETAILS_SUCCESS":
            return { ...state, loading: false, chatDetails: action.payload };
        case "GET_CHAT_DETAILS_FAILURE":
            return { ...state, loading: false, error: action.payload };
        case "CREATE_CHAT_REQUEST":
            return { ...state, loading: true };
        case "CREATE_CHAT_SUCCESS":
            return { ...state, loading: false, chats: [...state.chats, { id: action.payload } as ChatViewModel] };
        case "CREATE_CHAT_FAILURE":
            return { ...state, loading: false, error: action.payload };
        case "SEND_MESSAGE_REQUEST":
            return { ...state, loading: true };
        case "SEND_MESSAGE_SUCCESS":
            return {
                ...state,
                loading: false,
                chatDetails: state.chatDetails
                    ? { ...state.chatDetails, messages: [...(state.chatDetails.messages || []), action.payload as ChatMessageViewModel] }
                    : state.chatDetails,
            };
        case "SEND_MESSAGE_FAILURE":
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
